import React, { useEffect } from "react"
import { UploadedAttachment } from "../uploadAttachment/uploadedAttachment.component"
import { UploadingAttachment } from "../uploadAttachment/uploadingAttachment.component"

export const CustomTextField = ({ fieldName, children, setText, files, removeAttachment }) => {
    return (
        <>
            <div className="row" >
                <div className="col-12 col-lg-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="form-group">
                                <label className="font-lato mb-1">{fieldName}
                                    <span className="text-danger">*</span>
                                </label>
                                <textarea className="form-control" rows="3" onChange={(e) => setText(e.target.value)}>
                                </textarea>
                            </div>
                            {children}
                            <div className="row mt-1">
                                {files && files.map((file, index) => {
                                    return (
                                        <UploadedAttachment key={index} file={file} removeAttachment={removeAttachment}/>
                                    )
                                })}
                            </div>
                            
                            {files && files.map((file,index) => {
                               return  <UploadingAttachment key={index} file={file} removeAttachment={removeAttachment}/>
                            })}
                        </div>
                    </div>

                </div>
            </div>

        </>
    )
}